import { render, staticRenderFns } from "./FilterWidget.vue?vue&type=template&id=24983902&scoped=true&"
import script from "./FilterWidget.vue?vue&type=script&lang=js&"
export * from "./FilterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24983902",
  null
  
)

export default component.exports